import { MockScenario } from '@/util/xhr-mock';

export default {
  name: 'default',
  mocks: [],
} as MockScenario;
